import { render, staticRenderFns } from "./custom-form.vue?vue&type=template&id=9b9a3482&"
import script from "./custom-form.vue?vue&type=script&lang=js&"
export * from "./custom-form.vue?vue&type=script&lang=js&"
import style0 from "./custom-form.vue?vue&type=style&index=0&id=9b9a3482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports